import { render, staticRenderFns } from "./PdfPage.vue?vue&type=template&id=6c87bfac&scoped=true&"
import script from "./PdfPage.vue?vue&type=script&lang=js&"
export * from "./PdfPage.vue?vue&type=script&lang=js&"
import style0 from "./PdfPage.vue?vue&type=style&index=0&id=6c87bfac&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c87bfac",
  null
  
)

export default component.exports